import axios from 'axios'
import BlogDetail from 'apps/Blog/BlogDetail'
import { getCommonStaticProps } from 'commonPage'
import { safePromise } from 'utils/universal/safePromise'
import { mapBlogPost } from 'mappers/blogMapper'
import commonMessages from 'lang/es/common'
import vdpMessages from 'lang/es/vdp'
import blogMessages from 'lang/es/blog'
import get from 'lodash/get'

export default BlogDetail

export async function getStaticPaths() {
  const postsUrl = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/wp/v2/posts?per_page=100`
  const { result: postsResult } = await safePromise(axios(postsUrl))
  const posts = get(postsResult, 'data', [])
  // Get the paths we want to pre-render based on posts
  const paths = posts.map((post) => ({
    params: { slug: post.slug },
  }))

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: 'blocking' }
}

export async function getStaticProps({ params }) {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
    ...vdpMessages,
    ...blogMessages,
  }
  const blogSlug = params.slug
  const { result } = await safePromise(
    axios(
      `${process.env.NEXT_PUBLIC_API_WORDPRESS}/wp/v2/posts?_embed&&slug=${blogSlug}`,
    ),
  )
  const post = get(result, 'data.0', null)

  if (post === null) {
    return {
      notFound: true,
    }
  }

  const relatedUrl = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/wp/v2/posts?_embed&per_page=3&page=1&exclude=${post.id}&categories=${get(post, 'categories.0', 1)}`
  const { result: relatedResult } = await safePromise(axios(relatedUrl))
  const postsData = get(relatedResult, 'data', [])
  const relatedPosts = postsData.map(mapBlogPost)

  // Get the paths we want to pre-render based on posts
  return {
    props: {
      ...commonStaticProps,
      post,
      relatedPosts,
      /*       titleMeta: post.title.rendered,
      descriptionMeta: post.excerpt.rendered, */
      headerProps: {
        activeIndex: 4,
        breadcrumbs: [],
      },
      messages,
    },
  }
}
